<template>
    <AppHead title="Review Submitted">
        <meta name="robots" content="noindex, follow"/>
    </AppHead>

    <from-website :website="website">
        <div class="text-center mt-4">
            <img class="mx-auto" src="/images/misc/check-circle.svg">
        </div>

        <app-title class="font-bold text-center mt-4">Review Submitted</app-title>

        <p class="mt-4 text-center">
            Thank you for taking time to leave a review.
        </p>

        <p class="mt-4 text-center" v-if="!showTrustpilot">
            Redirecting you to <a :href="website.url" @click="redirect" class="font-bold text-black">
            {{ website.domain }}
        </a> in {{ count }}...
        </p>

        <template v-if="showTrustpilot">
            <hr class="max-w-[200px] border-black mx-auto my-8">

            <p class="mt-4 text-center max-w-lg mx-auto">
                We’d love it if you could leave your review on Trustpilot too. Simply copy your review below and
                following the link to paste it, it will only take 1 minute!
            </p>

            <AppTooltip class="w-full"
                        arrow
                        placement="top"
                        :hover="false"
                        :closeDelay="200"
                        :show="hasBeenCopied"
                        content="Copied!">
                <div class="flex items-center mt-8 gap-2 max-w-lg mx-auto">
                    <div class="flex-grow">
                        <InputBasic class="whitespace-nowrap"
                                    readonly
                                    type="text"
                                    ref="comment"
                                    :modelValue="review.comment"></InputBasic>
                    </div>

                    <AppButton theme="secondary" @click="copyReview">Copy</AppButton>
                </div>
            </AppTooltip>

            <div class="text-center">
                <a :href="`https://uk.trustpilot.com/evaluate/${website.trustpilot_name}`" target="_blank">
                    <AppButton class="mt-8">
                        Leave review on Trustpilot
                    </AppButton>
                </a>
            </div>
        </template>
    </from-website>
</template>

<script>
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import AppTitle from "@/Components/AppTitle.vue";
import FromWebsite from "@/Layouts/FromWebsite.vue";
import AppHead from "@/Components/AppSeoTags";
import InputBasic from "@/Components/Forms/Inputs/InputBasic";
import AppButton from "@/Components/AppButton";
import {useClipboard} from "@/Composables/useClipboard";
import AppTooltip from "@/Components/Utilities/AppTooltip";

export default {
    layout: null,
    components: {
        AppTooltip,
        AppButton,
        InputBasic,
        FontAwesomeIcon,
        AppTitle,
        FromWebsite,
        AppHead,
    },
    props: {
        website: Object,
        config: Object,
        review: Object
    },
    setup(props) {
        const {copy} = useClipboard();

        return {copy};
    },
    data() {
        return {
            count: 10,
            hasBeenCopied: false
        };
    },
    mounted() {
        this.startCount();
    },
    watch: {
        count(value) {
            if (value > 0) this.startCount();

            if (value <= 0) {
                this.redirect();
            }
        }
    },
    computed: {
        showTrustpilot() {
            return this.review.product.type === "website" && this.review.rating >= 8 && this.website.trustpilot_name;
        }
    },
    methods: {
        startCount() {
            if (this.showTrustpilot) return false;

            setTimeout(() => this.count--, 1000);
        },
        redirect() {
            if (this.config.env === "local") {
                alert("Redirect");
            } else {
                window.location.href = this.website.url;
            }
        },
        copyReview() {
            this.copy(this.review.comment).then(() => {
                this.hasBeenCopied = true;
            }).catch(error => {
                alert("There was an error copying the review, please copy it manually");
            });
        }
    }
};
</script>


<style lang="scss" scoped>

</style>
